import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { PlateDesktop } from '@alfa-bank/site-plate/desktop';

import type { IDeps, IProps } from '../models';

import { NoDeliveryBlock as Component } from './no-delivery-block';

export const NoDeliveryBlock = createWidget<IDeps, IProps>({ Plate: PlateDesktop })(Component);
